import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    this.setupFlatpickr();
  }

  setupFlatpickr() {
    let self = this;
    flatpickr('#datepicker', {
      mode: "range",
      altInput: true,
      altFormat: "J F Y",
      dateFormat: "Y-m-d",
      defaultDate: this.getPickerDates(),
      onChange: function(selectedDates, dateStr, instance) {
        if (selectedDates.length == 2) {
          self.setDateRange(selectedDates[0], selectedDates[1]);
        }
      },
      onReady: function(dateObj, dateStr, instance) {
        const input = instance.altInput || instance.input;
        input.setAttribute('aria-label', 'Select date range for the report');
      }
    });
  }

  setDateRange(date1, date2) {
    let url = new URL(location.href);
    url.searchParams.set('start', (date1.getTime()/1000).toString());
    url.searchParams.set('end', (date2.getTime()/1000).toString());
    // Preserve existing filters
    window.location.href = url.href;
  }

  getPickerDates() {
    let searchParams = new URLSearchParams(window.location.search);
    let start = searchParams.get('start');
    let end = searchParams.get('end');
    if (start && end) {
      return [new Date(start * 1000), new Date(end * 1000)];
    } else {
      let endDate = new Date();
      let startDate = new Date();
      startDate.setDate(endDate.getDate() - 7);
      return [startDate, endDate];
    }
  }
}
